import SvgOrImg from "./SvgOrImg";
export default SvgOrImg;
